(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver;
  var cursorStarted=false;

  function setSmoothState(running){
    window.dispatchEvent(new CustomEvent(running?'lenis:start':'lenis:stop'));
  }

  function initHeader(root){
    var header=(root.matches&&root.matches('[data-rc-header]'))?root:root.querySelector('[data-rc-header]');
    if(!header||header.dataset.rcReady==='true')return;
    header.dataset.rcReady='true';
    var burger=header.querySelector('[data-rc-burger]');
    var nav=header.querySelector('[data-rc-nav]');
    // Coalesced into one rAF per frame. Unthrottled, this read scrollY and
    // toggled a class on the sticky header on every scroll event, which on a
    // phone fires far more often than the compositor can paint.
    var scrollQueued=false;
    var applyScroll=function(){
      scrollQueued=false;
      header.classList.toggle('is-scrolled',window.scrollY>window.innerHeight*.6);
    };
    var onScroll=function(){
      if(scrollQueued)return;
      scrollQueued=true;
      window.requestAnimationFrame(applyScroll);
    };
    window.addEventListener('scroll',onScroll,{passive:true});
    applyScroll();
    if(burger&&nav){
      var close=function(){nav.classList.remove('is-open');burger.setAttribute('aria-expanded','false');setSmoothState(true)};
      burger.addEventListener('click',function(){
        var open=!nav.classList.contains('is-open');
        nav.classList.toggle('is-open',open);
        burger.setAttribute('aria-expanded',String(open));
        setSmoothState(!open);
      });
      nav.addEventListener('click',function(event){if(event.target.closest('a'))close()});
      document.addEventListener('keydown',function(event){if(event.key==='Escape')close()});
    }
  }

  function initAnnouncement(root){
    var bars=[];
    if(root.matches&&root.matches('[data-rc-announcement]'))bars.push(root);
    root.querySelectorAll('[data-rc-announcement]:not([data-rc-announcement-ready])').forEach(function(bar){bars.push(bar)});
    bars.forEach(function(bar){
      if(bar.dataset.rcAnnouncementReady==='true')return;
      bar.dataset.rcAnnouncementReady='true';
      var track=bar.querySelector('[data-rc-announcement-track]');
      var first=track&&track.querySelector('[data-rc-announcement-group]');
      if(!track||!first)return;
      var source=first.innerHTML;
      var repeatTemplate=document.createElement('div');
      repeatTemplate.innerHTML=source;
      repeatTemplate.querySelectorAll('[data-shopify-editor-block]').forEach(function(item){item.removeAttribute('data-shopify-editor-block')});
      var repeatSource=repeatTemplate.innerHTML;
      var frame;
      var build=function(){
        window.cancelAnimationFrame(frame);
        frame=window.requestAnimationFrame(function(){
          track.style.animation='none';
          track.innerHTML='';
          var group=document.createElement('div');
          group.className='rc-announcement__group';
          group.setAttribute('data-rc-announcement-group','');
          group.innerHTML=source;
          track.appendChild(group);
          // Measure once, then write once. This used to re-read scrollWidth
          // after every insert, forcing up to 20 synchronous reflows on a bar
          // that sits above the fold. Every copy is the same markup, so the
          // count needed follows arithmetically from a single measurement.
          var target=bar.clientWidth+80;
          var unit=group.scrollWidth;
          var copies=unit>0?Math.min(20,Math.max(0,Math.ceil((target-unit)/unit))):0;
          if(copies>0)group.insertAdjacentHTML('beforeend',repeatSource.repeat(copies));
          // Read the loop distance before the duplicate is appended, so the
          // clone doesn't cost a second layout pass.
          var loopDistance=group.scrollWidth;
          var duplicate=group.cloneNode(true);
          duplicate.setAttribute('aria-hidden','true');
          duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(function(item){item.removeAttribute('data-shopify-editor-block')});
          track.appendChild(duplicate);
          track.style.setProperty('--rc-loop-distance','-'+loopDistance+'px');
          void track.offsetWidth;
          track.style.animation='';
        });
      };
      build();
      if(document.fonts&&document.fonts.ready)document.fonts.ready.then(build);
      if('ResizeObserver'in window){
        var observer=new ResizeObserver(build);
        observer.observe(bar);
        bar.rcAnnouncementObserver=observer;
      }
    });
  }

  function initReveals(root){
    // The preloader covers the page on DOMContentLoaded. Observing now would
    // let above-the-fold reveals play out behind it, so the curtain would lift
    // on an already-static page. Wait for it to finish instead.
    if(document.documentElement.classList.contains('rc-preloading')){
      window.addEventListener('rc:preloader:done',function(){initReveals(root)},{once:true});
      return;
    }
    var items=root.querySelectorAll('.rc-reveal:not([data-rc-reveal-ready])');
    if(reduce||!('IntersectionObserver'in window)){
      items.forEach(function(item){item.dataset.rcRevealReady='true';item.classList.add('is-visible')});
      return;
    }
    if(!revealObserver){
      revealObserver=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target)}});
      },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    }
    items.forEach(function(item){item.dataset.rcRevealReady='true';revealObserver.observe(item)});
  }

  function initMagnetic(root){
    if(reduce||!window.matchMedia('(pointer:fine)').matches)return;
    root.querySelectorAll('[data-rc-magnetic]:not([data-rc-magnetic-ready])').forEach(function(item){
      item.dataset.rcMagneticReady='true';
      item.addEventListener('mousemove',function(event){var rect=item.getBoundingClientRect();var x=event.clientX-rect.left-rect.width/2;var y=event.clientY-rect.top-rect.height/2;item.style.transform='translate('+(x*.25)+'px,'+(y*.35)+'px)'});
      item.addEventListener('mouseleave',function(){item.style.transform=''})
    });
  }

  function initDrag(root){
    root.querySelectorAll('[data-rc-drag]:not([data-rc-drag-ready])').forEach(function(strip){
      strip.dataset.rcDragReady='true';
      var down=false,startX=0,startScroll=0,moved=0;
      strip.addEventListener('pointerdown',function(event){down=true;moved=0;startX=event.clientX;startScroll=strip.scrollLeft;strip.classList.add('is-dragging');strip.setPointerCapture(event.pointerId)});
      strip.addEventListener('pointermove',function(event){if(!down)return;var delta=event.clientX-startX;moved=Math.abs(delta);strip.scrollLeft=startScroll-delta});
      var end=function(){down=false;strip.classList.remove('is-dragging')};
      strip.addEventListener('pointerup',end);strip.addEventListener('pointercancel',end);strip.addEventListener('pointerleave',end);
      strip.addEventListener('click',function(event){if(moved>6){event.preventDefault();event.stopPropagation()}},true)
    });
  }

  function initParallax(root){
    root.querySelectorAll('[data-rc-parallax]:not([data-rc-parallax-ready])').forEach(function(scope){
      scope.dataset.rcParallaxReady='true';
      if(reduce)return;
      var items=Array.prototype.slice.call(scope.querySelectorAll('[data-rc-depth]'));
      if(!items.length)return;
      var onscreen=false,ticking=false;
      var strength=parseFloat(getComputedStyle(scope).getPropertyValue('--rc-parallax-strength'));
      if(isNaN(strength))strength=1;
      if(strength===0)return;

      // Transform-only writes, so this never triggers layout.
      function frame(){
        ticking=false;
        var rect=scope.getBoundingClientRect();
        var mid=rect.top+rect.height/2;
        var progress=(mid-window.innerHeight/2)/window.innerHeight;
        items.forEach(function(item){
          var depth=parseFloat(item.dataset.rcDepth)||0;
          item.style.transform='translate3d(0,'+(progress*depth*strength*-140).toFixed(2)+'px,0)';
        });
      }
      function onScroll(){if(!onscreen||ticking)return;ticking=true;requestAnimationFrame(frame)}

      if('IntersectionObserver'in window){
        new IntersectionObserver(function(entries){
          entries.forEach(function(entry){onscreen=entry.isIntersecting;if(onscreen)onScroll()});
        },{rootMargin:'150px 0px'}).observe(scope);
      }else{
        onscreen=true;
      }
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll,{passive:true});
      frame()
    });
  }

  function initCountdown(root){
    root.querySelectorAll('[data-rc-countdown]:not([data-rc-countdown-ready])').forEach(function(clock){
      clock.dataset.rcCountdownReady='true';
      var target=Date.parse(clock.dataset.deadline||'');
      var expired=clock.parentElement.querySelector('[data-rc-expired]');
      var units={days:clock.querySelector('[data-days]'),hours:clock.querySelector('[data-hours]'),minutes:clock.querySelector('[data-minutes]'),seconds:clock.querySelector('[data-seconds]')};
      function tick(){
        var distance=Number.isFinite(target)?target-Date.now():0;
        if(distance<=0){distance=0;if(expired)expired.hidden=false}
        units.days.textContent=String(Math.floor(distance/86400000)).padStart(2,'0');
        units.hours.textContent=String(Math.floor(distance%86400000/3600000)).padStart(2,'0');
        units.minutes.textContent=String(Math.floor(distance%3600000/60000)).padStart(2,'0');
        units.seconds.textContent=String(Math.floor(distance%60000/1000)).padStart(2,'0');
        if(distance<=0)window.clearInterval(timer)
      }
      var timer=window.setInterval(tick,1000);tick()
    });
  }

  function initMood(root){
    root.querySelectorAll('[data-rc-mood]:not([data-rc-mood-ready])').forEach(function(mood){
      mood.dataset.rcMoodReady='true';
      var stage=mood.querySelector('[data-rc-mood-stage]');
      var cards=Array.prototype.slice.call(mood.querySelectorAll('[data-rc-mood-card]'));
      var dots=Array.prototype.slice.call(mood.querySelectorAll('[data-rc-mood-dot]'));
      if(!stage||!cards.length)return;
      var count=cards.length;
      var active=1,timer=null,paused=false,onscreen=true,userPaused=false;
      var delay=parseInt(mood.dataset.autoplay,10)||0;
      var down=false,startX=0,moved=0;

      function setActive(n){
        active=(n-1+count)%count+1;
        mood.dataset.active=String(active);
        cards.forEach(function(card){
          var index=parseInt(card.dataset.index,10);
          // Signed offset, not raw modulo: positive is right of centre,
          // negative is left, at any card count. Raw modulo has no notion of
          // side, so the far cards land on the wrong side once count > 3.
          var raw=(index-active+count)%count;
          var pos=raw>count/2?raw-count:raw;
          card.dataset.pos=String(pos);
          card.setAttribute('aria-current',index===active?'true':'false');
          // Only the centre card and its two neighbours are painted; the rest
          // are stashed behind at opacity 0. Keep those out of the tab order
          // and off the a11y tree — the arrows and dots still reach them.
          var stashed=Math.abs(pos)>1;
          card.setAttribute('aria-hidden',stashed?'true':'false');
          var link=card.querySelector('[data-rc-mood-link]');
          if(link)link.setAttribute('tabindex',stashed?'-1':'0')
        });
        dots.forEach(function(dot){dot.setAttribute('aria-current',parseInt(dot.dataset.index,10)===active?'true':'false')})
      }

      function step(n){setActive(active+n)}
      function stop(){if(timer){window.clearInterval(timer);timer=null}}
      // userPaused is the explicit stop from the pause/play button and outranks
      // the transient hover/focus pause: it survives a mouseleave, so the slide
      // stays put until the visitor presses play again.
      function start(){stop();if(reduce||!delay||paused||!onscreen||userPaused)return;timer=window.setInterval(function(){step(1)},delay)}

      stage.addEventListener('pointerdown',function(event){down=true;moved=0;startX=event.clientX;stage.classList.add('is-dragging')});
      stage.addEventListener('pointermove',function(event){if(down)moved=event.clientX-startX});
      stage.addEventListener('pointerup',function(){if(!down)return;down=false;stage.classList.remove('is-dragging');if(Math.abs(moved)>40){step(moved<0?1:-1);start()}});
      stage.addEventListener('pointercancel',function(){down=false;moved=0;stage.classList.remove('is-dragging')});

      stage.addEventListener('click',function(event){
        var card=event.target.closest('[data-rc-mood-card]');
        if(!card)return;
        if(Math.abs(moved)>6){event.preventDefault();event.stopPropagation();return}
        var index=parseInt(card.dataset.index,10);
        if(index!==active){event.preventDefault();setActive(index);start()}
      },true);

      stage.addEventListener('focusin',function(event){
        var card=event.target.closest('[data-rc-mood-card]');
        if(card)setActive(parseInt(card.dataset.index,10))
      });

      dots.forEach(function(dot){dot.addEventListener('click',function(){setActive(parseInt(dot.dataset.index,10));start()})});
      var prev=mood.querySelector('[data-rc-mood-prev]');
      var next=mood.querySelector('[data-rc-mood-next]');
      if(prev)prev.addEventListener('click',function(){step(-1);start()});
      if(next)next.addEventListener('click',function(){step(1);start()});

      var toggle=mood.querySelector('[data-rc-mood-toggle]');
      if(toggle){
        // Under reduced motion the slide never autoplays, so a pause/play control
        // has nothing to act on — drop it from the row rather than leave a button
        // that toggles an icon but never moves anything.
        if(reduce){toggle.hidden=true}
        else{
          toggle.addEventListener('click',function(){
            userPaused=!userPaused;
            toggle.setAttribute('aria-pressed',String(userPaused));
            toggle.setAttribute('aria-label',userPaused?'Play auto-slide':'Pause auto-slide');
            if(userPaused)stop();else start();
          })
        }
      }

      mood.addEventListener('keydown',function(event){
        if(event.key==='ArrowLeft'){event.preventDefault();step(-1);start()}
        else if(event.key==='ArrowRight'){event.preventDefault();step(1);start()}
      });

      mood.addEventListener('mouseenter',function(){paused=true;start()});
      mood.addEventListener('mouseleave',function(){paused=false;start()});
      mood.addEventListener('focusin',function(){paused=true;start()});
      mood.addEventListener('focusout',function(event){if(!mood.contains(event.relatedTarget)){paused=false;start()}});

      if('IntersectionObserver' in window){
        new IntersectionObserver(function(entries){entries.forEach(function(entry){onscreen=entry.isIntersecting;start()})},{threshold:.2}).observe(mood)
      }

      mood.rcMoodStop=stop;
      setActive(1);start()
    });
  }

  // Home line-up: the hover photo tracks the cursor. Everything visual — the
  // fade, the scale, the resting position — is CSS on :hover/:focus-within, so
  // the section is already finished without this. All that happens here is that
  // --rc-peek-x/y get fed a lerped offset from the row's centre, which the
  // thumb consumes inside its own translate(). Custom-property writes only, so
  // no layout is triggered per frame.
  function initLineup(root){
    root.querySelectorAll('[data-rc-lineup]:not([data-rc-lineup-ready])').forEach(function(section){
      section.dataset.rcLineupReady='true';
      if(reduce||!window.matchMedia('(pointer:fine)').matches)return;
      var rows=Array.prototype.slice.call(section.querySelectorAll('[data-rc-lineup-row]'));
      if(!rows.length)return;
      var active=null,tx=0,ty=0,dx=0,dy=0,ticking=false;

      function frame(){
        ticking=false;
        if(!active)return;
        tx+=(dx-tx)*.16;ty+=(dy-ty)*.16;
        active.style.setProperty('--rc-peek-x',tx.toFixed(1)+'px');
        active.style.setProperty('--rc-peek-y',ty.toFixed(1)+'px');
        if(Math.abs(dx-tx)>.4||Math.abs(dy-ty)>.4)schedule()
      }
      function schedule(){if(!ticking){ticking=true;requestAnimationFrame(frame)}}
      function aim(row,event){
        var rect=row.getBoundingClientRect();
        dx=event.clientX-rect.left-rect.width/2;
        dy=event.clientY-rect.top-rect.height/2
      }

      rows.forEach(function(row){
        row.addEventListener('pointerenter',function(event){
          if(event.pointerType==='touch')return;
          active=row;aim(row,event);
          // Snap the start point to the cursor, otherwise the photo fades in
          // where the last row left it and slides across the screen.
          tx=dx;ty=dy;schedule()
        });
        row.addEventListener('pointermove',function(event){if(active===row){aim(row,event);schedule()}});
        row.addEventListener('pointerleave',function(){if(active===row)active=null})
      })
    });
  }

  // Home lookbook: the pinned rail follows whichever photo owns the middle of
  // the screen. The -45% insets shrink the observer's viewport to a thin band
  // across the centre, so a look only becomes active once it is genuinely the
  // one being looked at. In the gaps between photos nothing intersects and the
  // rail simply holds its last state, which is what stops it flickering.
  function initLookbook(root){
    root.querySelectorAll('[data-rc-lookbook]:not([data-rc-lookbook-ready])').forEach(function(section){
      section.dataset.rcLookbookReady='true';
      var figures=Array.prototype.slice.call(section.querySelectorAll('[data-rc-lookbook-figure]'));
      // With one look there is nothing to swap to, and without the observer the
      // markup's data-active="1" already leaves a usable rail.
      if(figures.length<2||!('IntersectionObserver'in window))return;
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){if(entry.isIntersecting)section.dataset.active=entry.target.dataset.figure});
      },{rootMargin:'-45% 0px -45% 0px'});
      figures.forEach(function(figure){observer.observe(figure)});
      section.rcLookbookStop=function(){observer.disconnect()}
    });
  }

  // Home polaroid wall: tapping a card opens it big instead of navigating.
  // The card's control is a real <a href> to the product, so with this script
  // absent — or on a browser without <dialog> — every polaroid is still a
  // working product link and nothing below runs. showModal() is what brings the
  // focus trap, Esc, the inert page behind and ::backdrop; the only thing left
  // to do by hand is restoring focus to the card that was clicked, since the
  // click is prevented before the link ever takes focus.
  function initWall(root){
    root.querySelectorAll('[data-rc-wall]:not([data-rc-wall-ready])').forEach(function(section){
      section.dataset.rcWallReady='true';
      var modal=section.querySelector('[data-rc-wall-modal]');
      if(!modal||typeof modal.showModal!=='function')return;

      var fields={
        image:modal.querySelector('[data-rc-wall-modal-image]'),
        code:modal.querySelector('[data-rc-wall-modal-code]'),
        name:modal.querySelector('[data-rc-wall-modal-name]'),
        note:modal.querySelector('[data-rc-wall-modal-note]'),
        price:modal.querySelector('[data-rc-wall-modal-price]'),
        compare:modal.querySelector('[data-rc-wall-modal-compare]'),
        cta:modal.querySelector('[data-rc-wall-modal-cta]')
      };
      function fill(card){
        var data=card.dataset;
        if(fields.image){fields.image.src=data.image||'';fields.image.alt=data.title||''}
        if(fields.code)fields.code.textContent=data.code||'';
        if(fields.name)fields.name.textContent=data.title||'';
        if(fields.note)fields.note.textContent=data.note||'';
        if(fields.price)fields.price.textContent=data.price||'';
        if(fields.compare)fields.compare.textContent=data.compare||'';
        if(fields.cta)fields.cta.href=data.url||'#';
      }

      section.addEventListener('click',function(event){
        var card=event.target.closest('[data-rc-wall-card]');
        if(!card||!section.contains(card))return;
        event.preventDefault();
        fill(card);
        // Focus the card's link BEFORE opening. showModal() remembers whatever
        // held focus and hands it back on close, so this one line is what
        // returns the visitor to the polaroid they opened — for Esc, the close
        // button and a backdrop click alike. Restoring it from the 'close'
        // event instead does not work: the browser's own restore runs after the
        // handler and puts focus back on <body>.
        var link=card.querySelector('[data-rc-wall-link]');
        if(link)link.focus({preventScroll:true});
        modal.showModal();
      });

      var close=modal.querySelector('[data-rc-wall-close]');
      if(close)close.addEventListener('click',function(){modal.close()});

      // Clicks land on the <dialog> itself only when they hit the backdrop —
      // anything inside the card stops at the card.
      modal.addEventListener('click',function(event){if(event.target===modal)modal.close()});

      section.rcWallStop=function(){if(modal.open)modal.close()}
    });
  }

  // Club Diary wall: a Pinterest grid, packed left to right.
  //
  // CSS cannot do this. Multi-column fills down each column, so photo 2 lands
  // under photo 1 and the top row reads 1, 5, 9; `grid-template-rows: masonry`
  // is not shipped. So the columns are built here.
  //
  // Crucially this is NOT the fragile kind of JS masonry the section used to
  // warn about: nothing is absolutely positioned and no image is ever measured.
  // Liquid emits each photo's true aspect ratio as --rc-ar, so a column's height
  // is just the running sum of 1/ratio in units of its own width. Every photo is
  // appended to whichever column is currently shortest, in document order, which
  // is what puts the first N across the top row and keeps the bottoms level.
  //
  // Because the maths needs no layout, the wall is correct before a single photo
  // has decoded, and there is nothing to re-run as they arrive. The section's
  // stylesheet renders the same flat list as justified rows until .is-columns
  // lands, so a failure here degrades to a good wall rather than a broken one.
  function initDiaryGrid(root){
    root.querySelectorAll('[data-rc-diary-grid]:not([data-rc-diary-grid-ready])').forEach(function(grid){
      grid.dataset.rcDiaryGridReady='true';

      // Held in document order so a repack always starts from the authored
      // sequence rather than from however the last pass happened to arrange it.
      var tiles=Array.prototype.slice.call(grid.querySelectorAll('.rc-diary__item'));
      if(!tiles.length)return;
      var ratios=tiles.map(function(tile){
        var value=parseFloat(tile.style.getPropertyValue('--rc-ar'));
        return value>0?value:0.75;
      });
      var current=0;

      function columnCount(){
        var value=parseInt(getComputedStyle(grid).getPropertyValue('--rc-cols'),10);
        return value>0?value:1;
      }

      function pack(){
        var count=columnCount();
        if(count===current)return;
        current=count;

        var columns=[],heights=[],i;
        for(i=0;i<count;i+=1){
          var column=document.createElement('div');
          column.className='rc-diary__column';
          columns.push(column);
          heights.push(0);
        }

        tiles.forEach(function(tile,index){
          // Leftmost on a tie, which is what makes the first `count` photos fill
          // the top row in order instead of stacking into one column.
          var shortest=0;
          for(var c=1;c<count;c+=1){
            if(heights[c]<heights[shortest]-1e-6)shortest=c;
          }
          columns[shortest].appendChild(tile);
          heights[shortest]+=1/ratios[index];
        });

        // One write. Rebuilding in place would detach and reattach every tile
        // on a wall that can run to 129 photos.
        var frame=document.createDocumentFragment();
        columns.forEach(function(column){frame.appendChild(column)});
        grid.textContent='';
        grid.appendChild(frame);
        grid.classList.add('is-columns');
      }

      pack();

      // Only the column count matters, and that changes at a breakpoint — not on
      // every pixel of a drag. Comparing against `current` inside pack() makes
      // the common resize a single getComputedStyle read and nothing else.
      var queued=false;
      window.addEventListener('resize',function(){
        if(queued)return;
        queued=true;
        window.requestAnimationFrame(function(){queued=false;pack()});
      },{passive:true});
    });
  }

  function initCursor(){
    if(cursorStarted||reduce||!window.matchMedia('(pointer:fine)').matches)return;
    var cursor=document.querySelector('[data-rc-cursor]');
    if(!cursor)return;
    cursorStarted=true;cursor.style.display='block';
    var ring=cursor.querySelector('.rc-cursor__ring');var x=innerWidth/2,y=innerHeight/2,rx=x,ry=y;
    document.addEventListener('mousemove',function(event){x=event.clientX;y=event.clientY});
    document.addEventListener('mouseover',function(event){cursor.classList.toggle('is-hot',Boolean(event.target.closest('a,button,input,select,textarea')))});
    function loop(){rx+=(x-rx)*.2;ry+=(y-ry)*.2;ring.style.transform='translate('+rx+'px,'+ry+'px) translate(-50%,-50%)';requestAnimationFrame(loop)}
    requestAnimationFrame(loop)
  }

  /* The bag count is server-rendered. Every in-theme publisher of cartUpdate
     already asks for the `cart-icon-bubble` section alongside its own and
     writes it into this link, so this is only a fallback for the paths that
     don't — bfcache restores and the manual `cart:refresh` event. It must not
     run after an add: it would re-render a whole page's worth of Liquid just
     for the count, and its answer lands after the drawer has already painted
     the right number, replacing it with whatever the response says. */
  var cartBubbleBusy=false;
  var cartBubbleStale=false;
  /* Sources whose own section render covers the bubble. (Adds aren't here:
     product-form.js reloads the page, so the count comes back server-rendered.) */
  var CART_BUBBLE_SELF_RENDERED=['cart-items','external-refresh'];
  function refreshCartBubble(){
    var link=document.getElementById('cart-icon-bubble');
    if(!link)return;
    /* A change landing mid-request would be answered by a response that
       predates it, so remember to go again rather than dropping it. */
    if(cartBubbleBusy){cartBubbleStale=true;return}
    cartBubbleBusy=true;
    /* Without this the browser can answer from cache with a count that
       predates the change we are refreshing for. */
    fetch(window.location.pathname+'?sections=cart-icon-bubble',{headers:{Accept:'application/json'},cache:'no-store'})
      .then(function(response){return response.ok?response.json():null})
      .then(function(data){
        var html=data&&data['cart-icon-bubble'];
        if(!html)return;
        var parsed=new DOMParser().parseFromString(html,'text/html');
        var section=parsed.querySelector('.shopify-section')||parsed.body;
        if(section)link.innerHTML=section.innerHTML;
      })
      .catch(function(){})
      .then(function(){
        cartBubbleBusy=false;
        if(cartBubbleStale){cartBubbleStale=false;refreshCartBubble()}
      });
  }

  function initCartBubble(){
    if(!document.getElementById('cart-icon-bubble')||window.rcCartBubbleReady)return;
    window.rcCartBubbleReady=true;
    /* Both are top-level `const`/`function` in Dawn's classic scripts, so they
       are global bindings but not window properties — feature-test by name. */
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate,function(event){
        if(event&&CART_BUBBLE_SELF_RENDERED.indexOf(event.source)!==-1)return;
        refreshCartBubble();
      });
    }
    document.addEventListener('cart:refresh',refreshCartBubble);
    /* Back-navigation restores the page from bfcache with whatever count it
       had when the user left it. */
    window.addEventListener('pageshow',function(event){if(event.persisted)refreshCartBubble()});
  }

  function watchCartDrawer(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer||drawer.dataset.rcObserved==='true')return;
    drawer.dataset.rcObserved='true';
    new MutationObserver(function(){setSmoothState(!drawer.classList.contains('active'))}).observe(drawer,{attributes:true,attributeFilter:['class']});
  }

  // Home diary teaser: two rails of photos strung on a thread, looping forever in
  // opposite directions. Same technique as the announcement bar above — pad the
  // group until it is wider than the rail, clone it once, then translate by the
  // group's MEASURED width. Translating by a guessed -50% is what produces the
  // jump at the loop point; measuring means the clone lands exactly where the
  // original started and the seam is invisible.
  //
  // Photo width is fixed in CSS, so scrollWidth is already correct before any
  // image has decoded. That is why there is no image-load rebuild here.
  function initDiaryRail(root){
    root.querySelectorAll('[data-rc-rail]:not([data-rc-rail-ready])').forEach(function(rail){
      rail.dataset.rcRailReady='true';
      var track=rail.querySelector('[data-rc-rail-track]');
      var group=track&&track.querySelector('[data-rc-rail-group]');
      if(!track||!group)return;

      // Reduced motion gets the single un-cloned set, which the stylesheet turns
      // into a hand-scrollable row. Cloning would only bury it in duplicates.
      if(reduce)return;

      var source=group.innerHTML;
      var repeatTemplate=document.createElement('div');
      repeatTemplate.innerHTML=source;
      repeatTemplate.querySelectorAll('[data-shopify-editor-block]').forEach(function(item){item.removeAttribute('data-shopify-editor-block')});
      var repeatSource=repeatTemplate.innerHTML;
      var lastWidth=-1;
      var frame;

      var build=function(){
        window.cancelAnimationFrame(frame);
        frame=window.requestAnimationFrame(function(){
          lastWidth=Math.round(rail.clientWidth);
          track.style.animation='none';
          track.innerHTML='';
          var first=document.createElement('div');
          first.className='rc-diary-rail__group';
          first.setAttribute('data-rc-rail-group','');
          first.innerHTML=source;
          track.appendChild(first);
          var originals=first.children.length;
          // Pad past the rail's own width so a section with two photos still
          // fills a desktop viewport instead of showing a gap every cycle.
          // Measured once rather than re-read per insert: the old loop forced
          // up to 20 synchronous reflows, twice over, since there are two rails.
          // lastWidth is the rail width already read above, so this costs one
          // layout pass in total. Every copy is the same markup, so the count
          // needed follows arithmetically.
          var railTarget=lastWidth+80;
          var railUnit=first.scrollWidth;
          var copies=railUnit>0?Math.min(20,Math.max(0,Math.ceil((railTarget-railUnit)/railUnit))):0;
          if(copies>0)first.insertAdjacentHTML('beforeend',repeatSource.repeat(copies));

          // Padded repeats and the clone are the same photos again. They stay
          // clickable — most of what is on screen at any moment is a copy, so
          // making them inert would leave dead photos in the rail — but they come
          // out of the tab order and out of the accessibility tree. Otherwise a
          // keyboard user tabs the same handful of photos twenty times over, and
          // a focusable link inside aria-hidden is its own violation.
          var mute=function(node){
            node.setAttribute('aria-hidden','true');
            node.querySelectorAll('a[href]').forEach(function(link){link.setAttribute('tabindex','-1')});
          };
          for(var c=originals;c<first.children.length;c+=1)mute(first.children[c]);

          // Measured before the clone is appended, so the duplicate doesn't
          // cost a second layout pass.
          var loopDistance=first.scrollWidth;
          var duplicate=first.cloneNode(true);
          mute(duplicate);
          duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(function(item){item.removeAttribute('data-shopify-editor-block')});
          track.appendChild(duplicate);
          track.style.setProperty('--rc-loop-distance','-'+loopDistance+'px');
          // Only now is it safe to animate — the stylesheet keeps the rail static
          // until this attribute lands, so it never runs on the keyframe's -50%
          // fallback and never jumps.
          rail.setAttribute('data-rc-rail-built','');
          void track.offsetWidth;
          track.style.animation='';
        });
      };
      build();

      if('ResizeObserver'in window){
        // Width only. Photos hang to different depths, so a rebuild can change
        // the rail's HEIGHT — observing that unguarded would have the observer
        // retrigger its own cause and spin.
        var observer=new ResizeObserver(function(entries){
          var width=Math.round(entries[0].contentRect.width);
          if(width===lastWidth)return;
          build();
        });
        observer.observe(rail);
        rail.rcRailObserver=observer;
      }
    });
  }

  // Footer "Size guide": opens the chart in place instead of sending someone off
  // the page they were about to buy from. The trigger stays a real <a> pointing
  // at the product page's own size chart anchor, so with this script absent, on a
  // browser without <dialog>, or if the popup is switched off in the editor, the
  // click still goes somewhere that answers the question.
  function initSizeGuide(root){
    var modal=root.querySelector('[data-rc-sizeguide]')||document.querySelector('[data-rc-sizeguide]');
    if(!modal||typeof modal.showModal!=='function')return;

    root.querySelectorAll('[data-rc-sizeguide-open]:not([data-rc-sizeguide-ready])').forEach(function(link){
      link.dataset.rcSizeguideReady='true';
      link.addEventListener('click',function(event){
        // Let modified clicks through — someone opening the chart in a new tab
        // wants the page, not a dialog they cannot see.
        if(event.metaKey||event.ctrlKey||event.shiftKey||event.button!==0)return;
        event.preventDefault();
        modal.showModal();
      });
    });

    if(modal.dataset.rcSizeguideBound==='true')return;
    modal.dataset.rcSizeguideBound='true';
    var close=modal.querySelector('[data-rc-sizeguide-close]');
    if(close)close.addEventListener('click',function(){modal.close()});
    // Clicking the backdrop lands on the <dialog> itself, never on the card.
    modal.addEventListener('click',function(event){if(event.target===modal)modal.close()});
  }

  function init(root){initAnnouncement(root);initHeader(root);initReveals(root);initMagnetic(root);initDrag(root);initParallax(root);initCountdown(root);initMood(root);initLineup(root);initLookbook(root);initWall(root);initDiaryRail(root);initDiaryGrid(root);initSizeGuide(root);initCursor();watchCartDrawer();initCartBubble()}
  function ready(){init(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
  document.addEventListener('shopify:section:unload',function(event){var bar=event.target.querySelector('[data-rc-announcement]');if(bar&&bar.rcAnnouncementObserver)bar.rcAnnouncementObserver.disconnect();var mood=event.target.querySelector('[data-rc-mood]');if(mood&&mood.rcMoodStop)mood.rcMoodStop();var look=event.target.querySelector('[data-rc-lookbook]');if(look&&look.rcLookbookStop)look.rcLookbookStop();var wall=event.target.querySelector('[data-rc-wall]');if(wall&&wall.rcWallStop)wall.rcWallStop();event.target.querySelectorAll('[data-rc-rail]').forEach(function(rail){if(rail.rcRailObserver)rail.rcRailObserver.disconnect()})});
})();
